
import {
  createContext
} from 'react';
import { BreadcrumbLink } from '@/types/app';

interface MenuLink {
  id: string;
  label: string;
  icon: React.ReactNode;
  href: string;
  isActive?: boolean;
}

export type { MenuLink };

export interface AppContextData {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  openSidebar: () => void;
  closeSidebar: () => void;
  menuLinks: MenuLink[];
  breadcrumbLinks: BreadcrumbLink[];
  setBreadcrumbLinks: (links: BreadcrumbLink[]) => void;
  getMenuLinksWithActive: () => MenuLink[];
}



export const AppContext = createContext<AppContextData>({} as AppContextData);